"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BonusTemplatesListCtl = /** @class */ (function (_super) {
    __extends(BonusTemplatesListCtl, _super);
    function BonusTemplatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_currency_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.currency_count; });
        _this.dk_language_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.language_count; });
        _this.dk_bonus_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_type_code; });
        _this.dk_bonus_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_type_title; });
        _this.dk_bonus_ttl_hours = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_ttl_hours; });
        _this.dk_is_bonus_has_ttl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_bonus_has_ttl; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_is_use_freespin = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_use_freespin; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTemplatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            bonus_type_filter: [],
            total: 0
        };
    };
    BonusTemplatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus template with id [" + id + "] not found !";
    };
    BonusTemplatesListCtl.prototype.getBonusTypeFilter = function () {
        return this.DATA.bonus_type_filter;
    };
    BonusTemplatesListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListBonusesTemplatesByBrandIdGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.bonus_type_filter = [];
            var bonus_type_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!bonus_type_filter_map.get(resp.list[i].bonus_type_title)) {
                    _this.DATA.bonus_type_filter.push({ text: resp.list[i].bonus_type_title, value: resp.list[i].bonus_type_title });
                    bonus_type_filter_map.set(resp.list[i].bonus_type_title, resp.list[i].bonus_type_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    currency_count: resp.list[i].currency_count,
                    language_count: resp.list[i].language_count,
                    bonus_ttl_hours: resp.list[i].bonus_ttl_hours,
                    bonus_type_code: resp.list[i].bonus_type_code,
                    bonus_type_title: resp.list[i].bonus_type_title,
                    is_bonus_has_ttl: resp.list[i].is_bonus_has_ttl,
                    is_deprecated: resp.list[i].is_deprecated,
                    is_locked: resp.list[i].is_locked,
                    title: resp.list[i].title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    is_use_freespin: resp.list[i].is_use_freespin
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplatesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusTemplate.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                bonus_type_code: data.bonus_type_code,
                bonus_ttl_hours: data.bonus_ttl_hours,
                is_bonus_has_ttl: data.is_bonus_has_ttl,
                is_deprecated: data.is_deprecated,
                is_locked: data.is_locked,
                description: data.description,
                is_use_freespin: data.is_use_freespin
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                currency_count: 0,
                language_count: 0,
                bonus_ttl_hours: data.bonus_ttl_hours,
                bonus_type_code: data.bonus_type_code,
                bonus_type_title: resp.bonus_type_title,
                is_bonus_has_ttl: data.is_bonus_has_ttl,
                is_deprecated: data.is_deprecated,
                is_locked: data.is_locked,
                title: data.title,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                description: data.description,
                is_use_freespin: data.is_use_freespin
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplatesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusTemplate.exec({
                data: {
                    bonus_template_id: data.key,
                    title: data.title,
                    bonus_ttl_hours: data.bonus_ttl_hours,
                    is_bonus_has_ttl: data.is_bonus_has_ttl,
                    is_deprecated: data.is_deprecated,
                    is_locked: data.is_locked,
                    description: data.description,
                    is_use_freespin: data.is_use_freespin
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.bonus_ttl_hours = data.bonus_ttl_hours;
                _tmp.is_bonus_has_ttl = data.is_bonus_has_ttl;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.is_locked = data.is_locked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.is_use_freespin = data.is_use_freespin;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplatesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTemplatesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusTemplate.exec({ data: { bonus_template_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplatesListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusTemplateIsLocked.exec({ data: { bonus_template_id: key, locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplatesListCtl.prototype.SetIsDeprecated = function (key, IsDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusTemplateIsDeprecated.exec({ data: { bonus_template_id: key, deprecated: IsDeprecated } }, function (resp) {
                _tmp.is_deprecated = IsDeprecated;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplatesListCtl.prototype.DoCloneBonusTemplates = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoCloneBonusTemplate.exec({ data: { bonus_template_id: key } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTemplatesListCtl;
}(BaseController_1.BaseController));
exports.BonusTemplatesListCtl = BonusTemplatesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ctl/BonusTemplatesListCtl.ts
// module id = 876
// module chunks = 0